/**
 * AYU — Gemeinsame Client-Konfiguration
 * Enthält App-weite Einstellungen, FAQ, Notfall-Hinweise
 */

export const sharedConfig = {
  /** App-Name */
  appName: "AYU",
  /** Logo URL */
  logoUrl: "https://d2xsxph8kpxj0f.cloudfront.net/310519663397508885/WZX5AU3w4QaCsGPxruXuzA/ayu-logo_gold.png",
  /** Support-Email */
  supportEmail: "support@ayu-rveda.ai",
  /** Notfall-Hinweis */
  emergencyNote: "Bei akuten gesundheitlichen Beschwerden wende dich bitte an deinen Arzt oder den ärztlichen Bereitschaftsdienst: 116 117 (kostenlos, 24/7)",
  /** FAQ-Einträge */
  faq: [
    {
      q: "Wie oft sollte ich das Tagebuch nutzen?",
      a: "Idealerweise täglich, auch wenn es nur 5 Minuten sind. Regelmäßigkeit ist wichtiger als Länge. Im Ayurveda ist die tägliche Selbstbeobachtung (Svadhyaya) ein wichtiger Baustein.",
    },
    {
      q: "Was ist der Unterschied zwischen Tagebuch und Annam?",
      a: "Das Tagebuch ist für deine tägliche Reflexion — kurze Einträge, Befinden festhalten, Muster erkennen. Annam ist für tiefere Gespräche — wenn du ein Thema wirklich durcharbeiten oder ayurvedische Empfehlungen erhalten möchtest.",
    },
    {
      q: "Werden meine Daten gespeichert?",
      a: "Deine Gespräche werden verschlüsselt gespeichert, damit AYU Muster über die Zeit erkennen kann. Nur du hast Zugriff auf deine Daten.",
    },
    {
      q: "Kann ich meinen Betreuer kontaktieren?",
      a: "Ja, über den Profil-Bereich kannst du jederzeit eine Nachricht an deinen Betreuer senden.",
    },
    {
      q: "Was sind die geführten Sessions?",
      a: "Die geführten Sessions umfassen Pranayama (Atemübungen), Meditation, Yoga Nidra und weitere ayurvedische Praktiken — personalisiert auf deinen Phänotyp.",
    },
  ],
  /** Versionshinweis */
  version: "2.0.0",
};
